module.exports = {"cn":{"contact":"联系方式","iphone":"电话","address":"地址","wechat":"微信","email":"邮箱","code":"扫码关注我们"},"en":{"contact":"Contact Information","iphone":"Telephone","address":"Address","wechat":"WeChat","email":"Email","code":"Scan code to follow us"}}


//////////////////
// WEBPACK FOOTER
// ./src/js/contact.json
// module id = Koi4
// module chunks = 1